import { useEffect } from "react";
import { LoginCta, PrimaryLink } from "./NudgeShared";
import styles from "./Gate.module.scss";
import cx from "classnames";

const Gate = () => {
  useEffect(() => {
    document.body.classList.add(styles.withGate);
    return () => document.body.classList.remove(styles.withGate);
  });

  return (
    <div className={styles.root} data-category="gateway interaction">
      <div className={styles.shadow} />
      <div
        className={styles.container}
        id="gate"
        data-testid="gate"
        aria-labelledby="gate"
        data-action="gateway:display"
        data-label="gate"
      >
        <p className={cx(styles.gateText, "gate__text")}>
          We hope you&apos;ve enjoyed your free articles.
        </p>
        <p className={cx(styles.gateTitle, "gate__title")}>
          Don&apos;t miss another story. Subscribe today.
        </p>
        <p className={cx(styles.gateText, "gate__dek")}>
          Subscribers enjoy unlimited access.
        </p>
        <div className={cx(styles.spacingContainer, "gate__spacing-container")}>
          <PrimaryLink
            text={"See Plans"}
            source={"gate"}
            isExpandedStyles={true}
            isCentered={true}
          />
        </div>
        <LoginCta includeText={true} source="gate" />
      </div>
    </div>
  );
};

export default Gate;
